export default __webpack_public_path__ + "static/media/ns_logo_autonomous.eb89037d.png";